import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { EbcontGalaxyModule } from '@ebcont/ebcont.galaxy.js';
import { HocModule } from '@hoc/hoc.module';
import { TeamModule } from '@modules/team/team.module';
import { TranslateModule } from '@ngx-translate/core';
import { CoreModule } from '@core/core.module';
import { GeneralModule } from '@modules/general/general.module';
import { RouterLinkActive } from '@angular/router';
import { CustomerListComponent } from '@modules/customer/components/customer-list/customer-list.component';
import { CustomerDetailsComponent } from '@modules/customer/components/customer-details/customer-details.component';
import { CustomerProjectListComponent } from '@modules/customer/components/customer-project-list/customer-project-list.component';

@NgModule({
  declarations: [CustomerListComponent, CustomerDetailsComponent, CustomerProjectListComponent],
  exports: [CustomerListComponent],
  imports: [
    CommonModule,
    EbcontGalaxyModule,
    HocModule,
    TeamModule,
    TranslateModule,
    CoreModule,
    GeneralModule,
    NgOptimizedImage,
    RouterLinkActive
  ]
})
export class CustomerModule {}
